import { IconSvgElement } from "@hugeicons/react";
import { IconAI } from "shared/components/ai/IconAI";

const HeadphonesIcon: IconSvgElement = [
  [
    "path",
    {
      d: "M2.75 13C2.75 7.89137 6.89137 3.75 12 3.75C17.1086 3.75 21.25 7.89137 21.25 13V16C21.25 16.4142 20.9142 16.75 20.5 16.75C20.0858 16.75 19.75 16.4142 19.75 16V13C19.75 8.71979 16.2802 5.25 12 5.25C7.71979 5.25 4.25 8.71979 4.25 13V16C4.25 16.4142 3.91421 16.75 3.5 16.75C3.08579 16.75 2.75 16.4142 2.75 16V13Z",
      fill: "currentColor",
      fillRule: "evenodd",
      key: "0"
    }
  ],
  [
    "path",
    {
      d: "M5.5 14.25C4.25736 14.25 3.25 15.2574 3.25 16.5V18.5C3.25 19.7426 4.25736 20.75 5.5 20.75C6.74264 20.75 7.75 19.7426 7.75 18.5V16.5C7.75 15.2574 6.74264 14.25 5.5 14.25ZM18.5 14.25C17.2574 14.25 16.25 15.2574 16.25 16.5V18.5C16.25 19.7426 17.2574 20.75 18.5 20.75C19.7426 20.75 20.75 19.7426 20.75 18.5V16.5C20.75 15.2574 19.7426 14.25 18.5 14.25Z",
      fill: "currentColor",
      fillRule: "evenodd",
      key: "1"
    }
  ]
];

export const IconAILeasingAgent = ({ bgSize = 44 }: { bgSize?: number }) => (
  <IconAI bgSize={bgSize} icon={{ Icon: HeadphonesIcon }} />
);
